/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { tagName } from '@ember-decorators/component';
import { inject as service } from '@ember/service';
import { not, and } from '@ember/object/computed';
import Component from '@ember/component';
import { task } from 'ember-concurrency';

@tagName('')
export default class ToggleVisibilityButton extends Component {
  @service api;
  @service apiErrors;
  @service alerts;
  @service store;

  // external API
  layoutItem = null;

  disabled = false;
  buttonClassNames = null;

  // internal state
  @not('layoutItem.archived') layoutIsActive;

  @and('layoutItem.isDefault', 'layoutIsActive') cannotToggleVisibility;

  toggleVisibility = task(
    {
      drop: true,
    },
    async () => {
      let layout = this.get('layoutItem');
      let archived = layout.get('archived');

      try {
        let response = await this.get('api').post(`layouts/${layout.get('id')}/archived`, {
          data: {
            archived: !archived,
          },
        });

        let message;

        if (archived) {
          message = 'Layout unarchived. You can find it in your active layouts.';
        } else {
          message = 'Layout archived. To use it in any new campaigns or newsletters, unarchive it.';
        }

        this.get('alerts').success('archived', message);
        this.store.pushPayload(response);
      } catch (errors) {
        this.get('apiErrors').report(errors);
      }
    },
  );
}
